import { I18nString } from '@models/i18n/i18n-string';
import { AdminUser } from './admin-user';
import { BinaryFile } from './binary-file';
import { I18nStringMap } from './i18n/i18n-string-map';
import { User } from './user';
import {OnepageField} from './onepage-template-field';
import { HtmlTemplate } from './html-template';
import { UUID } from 'angular2-uuid';

export type TemplateType = 'USER' | 'SYSTEM';


export class OnepageTemplate {

    id: string;
    onepageTemplateCode: string;
    templateFileName: string;
    templateFileCode: string;
    productName: string;
    description: string;
    merCode: string;
    status: string;
    currentVersion: number = 0;

    originalQuota: number = -1;
    quotaLeft: number = -1;

    // emailTemplateId: string;
    // code: string;
    // name: string;
    // remarks:string;
    // subject: string;
    onePageFields: OnepageField[];
    // content: string;
    htmlTemplate:BinaryFile;
    // type:TemplateType;
    htmlTemplateEntity: HtmlTemplate;

    companyTemplateLogoImage:BinaryFile;
    pageIconImage:BinaryFile;

    pageTitle: string;
    pageTitleTc: string;
    eventTitle: string;
    eventDescription1: string;
    eventDescription2: string;
    eventTitleTc: string;
    eventDescription1Tc: string;
    eventDescription2Tc: string;


	labelFontFamily: string;
	labelFontWeight: string;
	labelFontColor: string;
    pageBackgroundColor: string;
    foreGroundColor: string;
    customizedCSS: string;
    customizedCSSTc: string;

    tandC: string;
    tandCForTc: string;
    policy: string;
    showFaceBookIcon: boolean = false;
    showLineIcon: boolean = false;
    showIntIcon: boolean = false;
    showYouTubeIcon: boolean = false;

    removeCompanyName: boolean = false;
    removeContactNo: boolean = false;
    removeEmail: boolean = false;
    
	urlForFaceBookIcon: string;
    customizedIconForFaceBook: string;
	urlForLineIcon: string;
    customizedIconForLine: string;
	urlForIntIcon: string;
    customizedIconForInt: string;
	urlForYouTubeIcon: string;
    customizedIconForYouTube: string;
 
    startFrom: Date;
    endTo: Date;
    useProductQuota: boolean;

    publishLanguage: string="EN_AND_TC";

    constructor() {
        
        // this.templateFileName = new I18nStringMap();
        // let en = new I18nString();
        // let zh_tw = new I18nString();
        // let zh_cn = new I18nString();
        // en.locale = 'en';
        // zh_tw.locale = 'zh_TW';
        // zh_cn.locale = 'zh_CN';
        this.publishLanguage ='EN_AND_TC';
        this.status='ENABLED';

        // this.templateFileName.i18nStrings = [];
        // this.templateFileName.i18nStrings.push(en);
        // this.templateFileName.i18nStrings.push(zh_tw);
        // this.templateFileName.i18nStrings.push(zh_cn);
    }

    static search(term: string, item: OnepageTemplate) {
        term = term.toLocaleLowerCase();
        return true;//item.templateFileName.i18nStrings.findIndex(name => name.value.toLocaleLowerCase().indexOf(term) > -1) > -1;
        // return  item.templateFileName.toLocaleLowerCase().indexOf(term) > -1;
    }
}

export class  OnePageTemplateSearchingCriteria{
    htmlTemplateCode: string;   
    templateCode: string;
    productName: string;
    status: string='ENABLED';
}



export class  OnePageTemplateConfigSearchingCriteria{
    htmlTemplateFileName: string;   
    status: string='ENABLED';
}


export class OnepageTemplateConfig {
    id: string;
    htmlTemplateFileName: string;
    merCode: string;
    status: string;
    onepageTemplateAdminFieldControls: OnepageTemplateAdminFieldControl[];
    onepageTemplateFieldTypeConfigs: OnepageTemplateFieldTypeConfig[];
    defaultOnePageFields: DefaultOnePageField[];
}

export class DefaultOnePageField{
    id: string;
    fieldId: string;
    fieldName: string;
    fieldType: string;
    _uiFlagId: string;
    constructor() {
        this._uiFlagId = UUID.UUID();
    } 
}

export class OnepageTemplateFieldTypeConfig {
    id: string;
    fieldTypeName: string;
    controlledUiFieldIds: string;
    disableUiFieldIdsArr: string[];
    enabledUiFieldIdsArr: string[];
    enabled: boolean;
    _uiFlagId: string;
    constructor() {
        this._uiFlagId = UUID.UUID();
    } 
}
export class OnepageTemplateAdminFieldControl {
    id: string;
    entityFieldId: string;
    enabled: boolean;
    _uiFlagId: string;
    constructor() {
        this._uiFlagId = UUID.UUID();
    } 

}

export class  OnePageTemplateConfigCriteria{
    htmlTemplateFileName: string;   
    status: string='ENABLED';
}
